import api from '../api';

import { ParamsDataFaq } from 'utils/typeServices';

export const GetFaq = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<{ Data: Array<ParamsDataFaq> }>('v1/Faq', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
